import {Form} from 'antd';
import L from 'leaflet';
import isEqual from 'lodash/isEqual';
import PropTypes from 'prop-types';
import React, {memo, useMemo, useState} from 'react';
import {MapContainer, Marker, TileLayer, useMapEvents} from 'react-leaflet';

import CubaMapInternalLayout from '@/modules/company/components/OfficeMap/components/CubaMapInternalLayout';

const isNotZeroArray = (arr)=> {
  return !isEqual(arr, [0, 0]);
};

const MapViewer = ({
  coordinates,
  value,
  onChange,
  isOnClickActive,
  iconProps,
  province,
  municipality,
  ...props
}) => {
  const [offline, setOffline] = useState(false);
  delete L.Icon.Default.prototype._getIconUrl;
  const values = useMemo(() => value?.coordinates || coordinates, [value?.coordinates, coordinates]);
  const haveValue = useMemo(() => !!values?.length && isNotZeroArray(values), [values]);

  const centerMapValue = useMemo(() => {
    if (haveValue)
      if ((value?.coordinates || coordinates)?.[0] < 0)
        return (value?.coordinates?.reverse() || coordinates?.reverse() || []);
      else
        return (value?.coordinates || coordinates || []);
    return [23.12626, -82.37602]; //havana coords
  }, [haveValue, value, coordinates]);

  const icon = new L.Icon({
    iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-red.png',
    shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41],
    ...iconProps
  });

  function LocationMarker() {
    useMapEvents({
      click(e) {
        if (isOnClickActive && e?.latlng) {
          const location = Object.assign({}, {
            type: 'Point',
            coordinates: [e.latlng.lng, e.latlng.lat]
          });
          onChange(location);
        }
      }
    });
    if (value?.coordinates?.length) {
      if (value?.coordinates?.[0] < 0)
        return <Marker key={JSON.stringify(value?.coordinates?.reverse())} position={value?.coordinates} icon={icon}/>;
      else
        return <Marker key={JSON.stringify(value?.coordinates)} position={value?.coordinates} icon={icon}/>;
    }
    return <div/>;
  }

  function ViewMarker() {
    if (!isOnClickActive && coordinates?.length) {
      return <Marker position={coordinates} icon={icon}/>;
    }
    return null;
  }

  if (offline) return null;

  return (
    <MapContainer
      style={{height: 200, zIndex: 1}}
      center={centerMapValue}
      zoom={18}
      minZoom={6}
      scrollWheelZoom={true}
      {...props}
    >
      <CubaMapInternalLayout
        center={centerMapValue}
        zoomWithValue={haveValue}
        isOnClickActive={isOnClickActive}
        province={province}
        municipality={municipality}
      >
        <TileLayer
          attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          eventHandlers={{
            tileerror: () => setOffline(true)
          }}
        />
        <LocationMarker/>
        <ViewMarker/>
      </CubaMapInternalLayout>
    </MapContainer>
  );
};
export default memo(MapViewer);

MapViewer.propTypes = {
  value: PropTypes.object,
  iconProps: PropTypes.object,
  spaceId: PropTypes.string,
  province: PropTypes.string,
  municipality: PropTypes.string,
  onChange: PropTypes.any,
  isOnClickActive: PropTypes.bool,
  coordinates: PropTypes.any,
};

MapViewer.defaultProps = {
  isOnClickActive: true,
  value: {},
};

export const renderMapViewer = ({formItemProps, field}, province, {address} = {}) => {
  return (
    <Form.Item {...formItemProps} required={field?.required}>
      <MapViewer
        {...field?.widgetProps}
        {...field}
        province={province || address?.province}
      />
    </Form.Item>
  );
};
